export const GENERIC_GRID_FIELD_SET_QUOTA_SEARCH_LIST = 'GENERIC_GRID_FIELD_SET_QUOTA_SEARCH_LIST';
export const GENERIC_GRID_FIELD_SET_QUOTA_EDIT = 'GENERIC_GRID_FIELD_SET_QUOTA_EDIT';
export const GENERIC_GRID_FIELD_SET_QUOTA_EXISTING = 'GENERIC_GRID_FIELD_SET_QUOTA_EXISTING';
export const GENERIC_GRID_FIELD_SET_CURRENT_QUOTA = 'GENERIC_GRID_FIELD_SET_CURRENT_QUOTA';
